'use strict';

module.exports = {
    SCRIPT: 'jsError',
    AJAX: 'ajaxError',
    RESOURCE: 'resourceError'
};